import React, { useEffect, useRef, useState } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
type GalleryImageFrameProps = {
  src: string;
  alt: string;
  className?: string;
};
export function GalleryImageFrame({
  src,
  alt,
  className = ''
}: GalleryImageFrameProps) {
  const frameRef = useRef<HTMLDivElement>(null);
  const prefersReducedMotion = useReducedMotion();
  const [isMobile, setIsMobile] = useState(false);
  const {
    scrollYProgress
  } = useScroll({
    target: frameRef,
    offset: ['start end', 'end start']
  });
  const parallaxY = useTransform(scrollYProgress, [0, 0.5, 1], [-14, 0, 14]);
  const shouldAnimate = isMobile && !prefersReducedMotion;
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 639px)');
    const updateViewport = () => setIsMobile(mediaQuery.matches);
    updateViewport();
    mediaQuery.addEventListener('change', updateViewport);
    return () => mediaQuery.removeEventListener('change', updateViewport);
  }, []);
  return <div ref={frameRef} className="h-[330px] overflow-hidden sm:h-[370px]" data-id="element-76" data-mp="3u5kmcnk1g0ho">
      <motion.img src={src} alt={alt} style={shouldAnimate ? {
      y: parallaxY
    } : undefined} className={`h-[358px] w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03] sm:h-[370px] ${className}`} data-id="element-77" data-mp="2z9qd5tvxpx7" />
    </div>;
}